import {Text, type TextProps} from '@primer/react'
import {clsx} from 'clsx'
import type {CSSProperties} from 'react'

import {SanitizedHtml} from '../../dom/sanitized-html'
import styles from './text-cell.module.css'

export const TextCell = ({
  ref,
  children,
  dangerousHtml,
  className,
  isDisabled,
  isWrapping,
  lineClamp,
  ...rest
}: TextProps & {
  dangerousHtml?: string
  isDisabled?: boolean
  className?: string
  isWrapping?: boolean
  lineClamp?: number
} & {ref?: React.Ref<HTMLElement>}) => {
  const wrapStyle = isWrapping && lineClamp ? ({'--line-clamp': lineClamp} as CSSProperties) : undefined

  if (dangerousHtml) {
    return (
      <SanitizedHtml
        {...rest}
        ref={ref}
        aria-disabled={isDisabled}
        className={clsx(className, styles.SanitizedHtml, isWrapping && styles.wrapping)}
        style={wrapStyle}
      >
        {dangerousHtml}
      </SanitizedHtml>
    )
  }

  return (
    <Text
      {...rest}
      aria-disabled={isDisabled}
      ref={ref}
      className={clsx(className, styles.SanitizedHtml, isWrapping && styles.wrapping)}
      style={wrapStyle}
    >
      {children}
    </Text>
  )
}

TextCell.displayName = 'TextCell'
